import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "const/constants";

export const REFERRAL_POLICY_KEY = ["referral-policy"];

export const fetchReferralPolicy = async () => {
  const { data } = await axios.get(`${API_URL}/referral-policy`);
  const policy = data?.data ?? data;
  return { nonReferralUsersAllowed: Boolean(policy?.nonReferralUsersAllowed) };
};

/**
 * Whether office staff may be referrers in this deployment. The server decides and enforces it on
 * every write; the app reads it only to avoid offering what would be refused. Anything other than a
 * clear "allowed" (still loading, request failed) reads as not allowed.
 */
export const useReferralPolicy = () =>
  useQuery(REFERRAL_POLICY_KEY, fetchReferralPolicy, {
    staleTime: 5 * 60_000,
    retry: false,
  });

export const useStaffMayRefer = () => Boolean(useReferralPolicy().data?.nonReferralUsersAllowed);
